import { IconProps } from 'types/icon.type'

export const XLogoIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>X icon</title>
      <path
        d="M13.5978 10.7136L19.8516 3.59998H18.3694L12.9406 9.77638L8.6026 3.59998H3.60003L10.159 12.9408L3.60003 20.4H5.08227L10.8161 13.8768L15.3975 20.4H20.4L13.5978 10.7136ZM5.61588 4.69198H7.89236L18.3706 19.3584H16.0941L5.61588 4.69198Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5978 10.7136L20.4 20.4H15.3975L10.8161 13.8768L5.08227 20.4H3.60003L10.159 12.9408L3.60003 3.59998H8.6026L12.9406 9.77638L18.3694 3.59998H19.8516L13.5978 10.7136ZM12.9512 9.58261L8.66496 3.47998H3.36914L10.0065 12.9325L3.33472 20.52H5.13656L10.8055 14.0705L15.3351 20.52H20.6309L13.7502 10.7219L20.1169 3.47998H18.3151L12.9512 9.58261ZM16.1559 19.2384H18.1374L7.83061 4.81198H5.84911L16.1559 19.2384ZM16.0941 19.3584H18.3706L7.89236 4.69198H5.61588L16.0941 19.3584Z"
        fill="currentColor"
      />
    </svg>
  )
}
